import React from "react";
import { Cookie } from "lucide-react";

// Bottom cookie-consent banner. Analytics stays off until the user clicks
// "Accept". Choice is persisted by the parent (App) in localStorage, so the
// banner only appears until a choice is made (or when re-opened via the footer).
const CookieConsent = ({ onAccept, onDecline, onOpenPrivacy, onOpenTerms }) => {
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4">
      <div className="max-w-3xl mx-auto bg-gray-800/95 backdrop-blur-sm border-2 border-cyan-500/40 rounded-2xl shadow-2xl p-4 sm:p-5">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <Cookie className="w-6 h-6 text-yellow-400 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-gray-300 leading-relaxed">
              We use cookies for analytics to understand how the app is used and
              improve it. Your habit and goal data is never sold. See our{" "}
              <button
                onClick={onOpenPrivacy}
                className="text-cyan-300 underline hover:text-cyan-200"
              >
                Privacy Policy
              </button>{" "}
              and{" "}
              <button
                onClick={onOpenTerms}
                className="text-cyan-300 underline hover:text-cyan-200"
              >
                Terms
              </button>
              .
            </p>
          </div>
          <div className="flex gap-2 flex-shrink-0">
            <button
              onClick={onDecline}
              className="flex-1 sm:flex-none px-4 py-2 rounded-xl bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm font-semibold transition-colors"
            >
              Decline
            </button>
            <button
              onClick={onAccept}
              className="flex-1 sm:flex-none px-4 py-2 rounded-xl bg-gradient-to-r from-yellow-400 to-cyan-400 hover:from-yellow-300 hover:to-cyan-300 text-black text-sm font-semibold transition-colors"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
